import React from 'react'

import clsx from 'clsx'

import Link from 'components/Link'
import NextImage from 'components/NextImage'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import classes from './Hub.module.scss'

/** @type {import("./types").default} */
const Hub = ({ image, title, category, content, url }) => {
  const { addEvent } = useEventContext()

  return (
    <Link
      href={url}
      data-testid="hub-slide"
      className={classes.root}
      {...addEvent({
        engagementComponent: 'category_hub',
        engagementDestination: 'go-to_hub-pages',
        engagementDetails: 'card_hub-page',
        name: 'engagement_facet_click',
      })}
    >
      <div className={classes.imageContainer}>
        <NextImage src={image.url} alt={title} layout="fill" loading="lazy" />
      </div>
      <div className={clsx(classes.category, classes.chip)}>
        <Typography variant="tight-xxs" component="span">
          {category}
        </Typography>
      </div>
      <Typography variant="heading-md" className={classes.title}>
        {title}
      </Typography>

      <Typography variant="body-sm" className={classes.content}>
        {content}
      </Typography>
    </Link>
  )
}

export default Hub
